const { default: Ruler } = require('../modules/ruler');

module.exports = function (S) {
  const svgroot = S.svgroot;
  const getNextId = S.getNextId;
  const addSvgElementFromJson = S.addSvgElementFromJson;
  const canvas = S.canvas;
  const defaultPrecision = 10;

  let rulerH;
  let rulerV;

  let units = 'px';
  let factor = 1;
  let isRulersEnabled = false;
  let isRulersShown = false;
  let isGuidesShown = false;

  function precision (value) {
    return Math.round(value * defaultPrecision) / defaultPrecision;
  }

  function initRulerH () {
    if (rulerH) return;
    const $rulerHorizontal = $('#ruler-horizontal');
    const zoom = canvas.getZoom();

    $rulerHorizontal.show();
    rulerH = new Ruler({
      wrapper: document.getElementById('ruler-horizontal'),
      layout: 'horizontal',
      alignment: 'bottom',
      zoom,
      multiplier: canvas.zoomMultiplier,
      value: parseInt(canvas.contentW),
      factor,
      textDefaults: {
        centerText: {
          by: 'width',
          operation: 'sub' // 'sum' or 'sub'
        }
      }
    });

    rulerH.resize(zoom, canvas.zoomMultiplier);
    $rulerHorizontal.on('click', onGuideLineClick);
    $rulerHorizontal.on('contextmenu', onGuideLineContextmenu);
  }

  function initRulerV () {
    if (rulerV) return;
    const $rulerVertical = $('#ruler-vertical');
    const zoom = canvas.getZoom();

    $rulerVertical.show();
    rulerV = new Ruler({
      wrapper: document.getElementById('ruler-vertical'),
      layout: 'vertical',
      alignment: 'right',
      zoom,
      multiplier: canvas.zoomMultiplier,
      value: parseInt(canvas.contentH),
      factor,
      textDefaults: {
        rotation: -90,
        centerText: {
          by: 'height',
          operation: 'sum' // 'sum' or 'sub'
        }
      },
      texts: [
        {
          pixelGap: 100,
          offset: 25
        }
      ]
    });

    rulerV.resize(zoom, canvas.zoomMultiplier);
    $rulerVertical.on('click', onGuideLineClick);
    $rulerVertical.on('contextmenu', onGuideLineContextmenu);
  }

  function getSvgCanvasGuide (svgdoc, NS) {
    let canvasGuide = $('#canvasGuide')[0];

    if (!canvasGuide) {
      const canvBG = $('#svgpanel');
      canvasGuide = svgdoc.createElementNS(NS.SVG, 'svg');

      canvas.assignAttributes(canvasGuide, {
        id: 'canvasGuide',
        width: '100%',
        height: '100%',
        x: 0,
        y: 0,
        overflow: 'visible',
        style: 'pointer-events: none;'
      });

      canvBG.append(canvasGuide);
    }

    return canvasGuide;
  }

  function drawGuideLine (data) {
    const isVerticalRuler = data.isVerticalRuler;
    const guidePosition = data.guidePosition;
    const isGuideLine = data.isGuideLine;

    const guideId = 'guide-' + (isVerticalRuler ? 'y-' : 'x-') + guidePosition;
    const zoom = canvas.getZoom();
    const $svgContent = $('#svgcontent');

    const NS = svgedit.NS;
    const svgdoc = document.getElementById('svgcanvas').ownerDocument;
    const canvasGuide = getSvgCanvasGuide(svgdoc, NS);

    if (!isGuideLine) {
      const guideMarker = svgdoc.createElementNS(NS.SVG, 'rect');
      canvas.assignAttributes(guideMarker, {
        id: guideId + '-mark',
        x: isVerticalRuler ? 0 : guidePosition - 10,
        y: isVerticalRuler ? guidePosition - 10 : 5,
        width: isVerticalRuler ? 15 : 20,
        height: isVerticalRuler ? 20 : 15,
        fill: '#3bd4e3',
        style: 'cursor:pointer;pointer-events:all',
        class: 'canvas-guide-marker'
      });

      const $ruler = $('#ruler-' + (isVerticalRuler ? 'vertical' : 'horizontal'));

      $ruler.find('>svg')[0].append(guideMarker);
      $(guideMarker).on('click', function (event) {
        $(guideMarker).remove();
        $('#' + guideId).remove();
        event.stopPropagation();
      });
    }

    const guide = svgdoc.createElementNS(NS.SVG, 'rect');

    canvas.assignAttributes(guide, {
      id: guideId,
      x: isVerticalRuler ? $svgContent.attr('x') * zoom : guidePosition,
      y: isVerticalRuler ? guidePosition : $svgContent.attr('y') * zoom,
      width: isVerticalRuler ? $svgContent.attr('width') * zoom : 1,
      height: isVerticalRuler ? 1 : $svgContent.attr('height') * zoom,
      fill: isGuideLine ? '#2c353f' : '#3bd4e3',
      class: isGuideLine ? 'guide-line' : ''
    });

    canvasGuide.append(guide);
  }

  function onGuideLineContextmenu (event) {
    INKIVE.ContextMenu.handleContextMenu(event);
  }

  function onGuideLineClick (event) {
    const isVertical = $(event.currentTarget).is('#ruler-vertical');

    const guidePosition =
      Math.ceil((isVertical ? event.offsetY : event.offsetX) / 5) * 5;
    const zoom = canvas.getZoom();
    const $svgContent = $('#svgcontent');

    isInsideLimits() &&
      drawGuideLine({
        isVerticalRuler: isVertical,
        guidePosition
      });

    function isInsideLimits () {
      if (isVertical) {
        const y = $svgContent.attr('y') * zoom;
        return (
          guidePosition >= y &&
          guidePosition <= y + $svgContent.attr('height') * zoom
        );
      } else {
        const x = $svgContent.attr('x') * zoom;
        return (
          guidePosition >= x &&
          guidePosition <= x + $svgContent.attr('width') * zoom
        );
      }
    }
  }

  function updateSize () {
    if (!isRulersEnabled) return;

    rulerH.config.value = canvas.contentW;
    rulerV.config.value = canvas.contentH;
  }

  function updateFactor () {
    const format = INKIVE.Helpers.getInlineSize();
    factor = canvas.contentW / INKIVE.Helpers.convertUnitsToPixels(format.width, format.unit);
  }

  function resetObjectBorderLine (target) {
    if (target) {
      if ($('.borderLineGroup').length) {
        const g = $('.borderLineGroup').get(0);
        const elem = g.childNodes;
        let i = 0;

        while (i < elem.length) {
          if ($(elem[i]).hasClass('borderline_' + target)) {
            g.removeChild(elem[i]);
          } else {
            i++;
          }
        }
      }
    } else {
      if ($('.borderLineGroup').length) {
        const g = $('.borderLineGroup').get(0);
        g.parentNode.removeChild(g);
      }
    }
  }

  function drawObjectsBorderLine (selectedElems) {
    selectedElems = Array.from(selectedElems);
    selectedElems = selectedElems.filter((elem) => {
      return INKIVE.RestrictionsFacade.canChange(elem, 'position');
    });

    if (!isRulersEnabled) return;
    let canMove, selected;
    let coord = {};
    const xCoords = [];
    const yCoords = [];

    if (selectedElems.length > 1) {
      selected = selectedElems[0];
      canMove = true;

      for (let i = 0; i < selectedElems.length; i++) {
        const elemCoord = INKIVE.Helpers.getSelectedCoordinates(selectedElems[i]);
        xCoords.push(elemCoord.x1, elemCoord.x2, elemCoord.x3, elemCoord.x4);
        yCoords.push(elemCoord.y1, elemCoord.y2, elemCoord.y3, elemCoord.y4);
      }

      const minX = Math.min(...xCoords);
      const minY = Math.min(...yCoords);
      const maxX = Math.max(...xCoords);
      const maxY = Math.max(...yCoords);

      coord = {
        x1: minX,
        y1: minY,
        x2: maxX,
        y2: minY,
        x3: minX,
        y3: maxY,
        x4: maxX,
        y4: maxY,
        x5: (minX + maxX) / 2,
        y5: (minY + maxY) / 2
      };
    } else if (selectedElems.length === 1) {
      selected = selectedElems[0];
      canMove = INKIVE.RestrictionsFacade.canChange(selected, 'position');
      coord = INKIVE.Helpers.getSelectedCoordinates(selected);
    } else {
      return;
    }

    if (!coord) return false;

    coord.sx = 15;
    coord.sy = 15;

    resetObjectBorderLine();

    for (let i = 0; i < selectedElems.length; i++) {
      const isLocked = selectedElems[i].classList.contains('locked') ||
        selectedElems[i].classList.contains('non-selectable');
      if (isLocked || !canMove) return;
    }

    const id = selected.getAttribute('id');

    const guideLineGroup = $('.borderLineGroup').length
      ? $('.borderLineGroup').get(0)
      : addSvgElementFromJson(
        {
          element: 'g',
          curStyles: false,
          attr: {
            id: getNextId() + '_borderLine',
            class: isGuidesShown
              ? 'borderLineGroup'
              : 'borderLineGroup hidden'
          }
        },
        $('#svgpanel').get(0)
      );

    $(guideLineGroup).insertBefore($('#selectorParentGroup'));
    const zoom = canvas.getZoom();

    // Here are coords for each vertex (4 vertices): vertical and horizontal guidelines
    const arrLine = [
      { x1: coord.sx, y1: coord.y1, x2: coord.x1, y2: coord.y1 }, // top left horizontal
      { x1: coord.x1, y1: coord.sy, x2: coord.x1, y2: coord.y1 },
      { x1: coord.sx, y1: coord.y2, x2: coord.x2, y2: coord.y2 }, // top right horizontal
      { x1: coord.x2, y1: coord.sy, x2: coord.x2, y2: coord.y2 },
      { x1: coord.sx, y1: coord.y3, x2: coord.x3, y2: coord.y3 }, // bottom left horizontal
      { x1: coord.x3, y1: coord.sy, x2: coord.x3, y2: coord.y3 },
      { x1: coord.sx, y1: coord.y4, x2: coord.x4, y2: coord.y4 }, // bottom right horizontal
      { x1: coord.x4, y1: coord.sy, x2: coord.x4, y2: coord.y4 }
    ];

    if (selectedElems.length > 1) {
      arrLine[1].x2 = coord.x3;
      arrLine[1].y2 = coord.y3 - coord.sy;
      arrLine[3].x2 = coord.x4;
      arrLine[3].y2 = coord.y4 - coord.sy;
    }

    const rcr = $('#svgroot').get(0).getBoundingClientRect();
    const ccr = $('#canvasBackground').get(0).getBoundingClientRect();

    const offsetX = ccr.left - rcr.left;
    const offsetY = ccr.top - rcr.top;

    let value;
    const coordsH = [];
    const coordsV = [];
    let maxX = 0;
    let minX = Infinity;
    let maxY = 0;
    let minY = Infinity;
    for (let i = 0; i < arrLine.length; i++) {
      const isHorizontal = !(i % 2);
      const valH = arrLine[i].y2;
      const valV = arrLine[i].x2;

      if (isHorizontal) {
        if (coordsH.includes(valH)) continue;

        coordsH.push(valH);
        if (maxY < valH) maxY = valH;
        if (minY > valH) minY = valH;
      } else {
        if (coordsV.includes(valV)) continue;

        coordsV.push(valV);
        if (maxX < valV) maxX = valV;
        if (minX > valV) minX = valV;
      }

      canvas.addSvgElementFromJson(
        {
          element: 'line',
          attr: {
            class: 'guideline_' + id,
            stroke: arrLine[i].stroke ? arrLine[i].stroke : 'gray',
            'stroke-width': '1',
            'pointer-events': 'none',
            'stroke-dasharray': '5 3',
            x1: arrLine[i].x1 + (isHorizontal ? 0 : offsetX),
            y1:
              arrLine[i].y1 +
              (isHorizontal ? offsetY : offsetY + arrLine[i].y2),
            x2: offsetX + arrLine[i].x2,
            y2: isHorizontal
              ? offsetY + arrLine[i].y2
              : zoom * svgroot.getAttribute('height') - 45
          }
        },
        guideLineGroup
      );

      const text = canvas.addSvgElementFromJson(
        {
          element: 'text',
          attr: {
            'font-size': 10,
            fill: '#000',
            x: arrLine[i].x1 + (isHorizontal ? 12 : 2 + offsetX),
            y:
              arrLine[i].y1 +
              (isHorizontal
                ? -5 + offsetY
                : zoom * svgroot.getAttribute('height') - 65)
          }
        },
        guideLineGroup
      );

      value = isHorizontal
        ? valH / zoom - canvas.contentH / 2
        : valV / zoom - canvas.contentW / 2;

      if (units !== 'px') {
        value = INKIVE.Helpers.convertPixelsToUnits(value, units) / factor;
      }

      text.textContent = precision(value);
    }

    // distance X
    if (maxX - minX > canvas.zoomUnitSizeMin) {
      canvas.addSvgElementFromJson(
        {
          element: 'rect',
          attr: {
            fill: 'gray',
            'pointer-events': 'none',
            x: offsetX + minX,
            y: zoom * svgroot.getAttribute('height') - 45,
            width: maxX - minX,
            height: 2
          }
        },
        guideLineGroup
      );

      const text = canvas.addSvgElementFromJson(
        {
          element: 'text',
          attr: {
            'font-size': 9,
            fill: 'gray',
            'text-anchor': 'middle',
            x: offsetX + minX + (maxX - minX) / 2,
            y: zoom * svgroot.getAttribute('height') - 50
          }
        },
        guideLineGroup
      );

      value = (maxX - minX) / zoom;

      if (units !== 'px') {
        value = INKIVE.Helpers.convertPixelsToUnits(value, units) / factor;
      }

      text.textContent = precision(value);
    }

    // distance Y
    if (maxY - minY > canvas.zoomUnitSizeMin) {
      canvas.addSvgElementFromJson(
        {
          element: 'rect',
          attr: {
            fill: 'gray',
            'pointer-events': 'none',
            x: 22,
            y: offsetY + minY,
            width: 2,
            height: maxY - minY
          }
        },
        guideLineGroup
      );

      const text = canvas.addSvgElementFromJson(
        {
          element: 'text',
          attr: {
            'font-size': 9,
            fill: 'gray',
            'text-anchor': 'middle',
            x: 32,
            y: offsetY + minY + (maxY - minY) / 2,
            transform:
              'rotate(-90 ' +
              32 +
              ' ' +
              (offsetY + minY + (maxY - minY) / 2) +
              ')'
          }
        },
        guideLineGroup
      );

      value = (maxY - minY) / zoom;

      if (units !== 'px') {
        value = INKIVE.Helpers.convertPixelsToUnits(value, units) / factor;
      }

      text.textContent = precision(value);
    }

    return true;
  }

  const showRulers = function () {
    if (isRulersShown) return;

    isRulersShown = true;

    moveBottomElementsOnRulerDisplay(isRulersShown);

    $('#ik-grid-snap').show();
    document.getElementById('ruler-horizontal').classList.remove('hidden');
    document.getElementById('ruler-vertical').classList.remove('hidden');
  };

  const hideRulers = function () {
    if (!isRulersShown) return;

    isRulersShown = false;

    moveBottomElementsOnRulerDisplay(isRulersShown);

    $('#ik-grid-snap').hide();
    document.getElementById('ruler-horizontal').classList.add('hidden');
    document.getElementById('ruler-vertical').classList.add('hidden');
  };

  const showGuides = function () {
    if (isGuidesShown) return;

    isGuidesShown = true;

    const borderLineGroup = document.getElementsByClassName('borderLineGroup')[0];
    // Only exists while an element is selected
    if (borderLineGroup) borderLineGroup.classList.remove('hidden');
  };

  const hideGuides = function () {
    if (!isGuidesShown) return;

    isGuidesShown = false;

    const borderLineGroup = document.getElementsByClassName('borderLineGroup')[0];
    // Only exists while an element is selected
    if (borderLineGroup) borderLineGroup.classList.add('hidden');
  };

  return {
    updateUnits: function (u) {
      units = u;

      if (!isRulersEnabled || INKIVE.C.IS_MOBILE) return;

      updateFactor();
      rulerH.setUnits(u, factor);
      rulerV.setUnits(u, factor);
      this.repositionRulers();
    },

    clear: function (opts) {
      resetObjectBorderLine();
      this.selectedChanged(opts);
    },

    selectedChanged: function (opts) {
      if (!isRulersEnabled) {
        resetObjectBorderLine();
        return;
      }

      const mode = canvas.getMode();

      canvas.validateSelectedElems();

      const selected = canvas.getSelectedElems();
      const length = selected.length;
      if (!selected || !length) {
        resetObjectBorderLine();
        return;
      }

      if (
        $.inArray(mode, ['select', 'multiselect']) >= 0 &&
        selected.length >= 1
      ) {
        drawObjectsBorderLine(selected);
      }
    },

    mouseMove: function (opts) {
      if (!isRulersEnabled) return;

      const mode = canvas.getMode();
      const selected = canvas.getSelectedElems();
      const length = selected.length;

      if (!selected || !length) {
        resetObjectBorderLine();
        return;
      }

      if ($.inArray(mode, ['select', 'resize', 'rotate']) >= 0) {
        drawObjectsBorderLine(selected);
      } else {
        resetObjectBorderLine();
      }
    },

    zoomChanged: function () {
      if (!isRulersEnabled) return;
      const workArea = document.querySelector('#workarea');
      workArea.scrollTop = 0;

      $('#canvasGuide').find('rect').remove();
      $('.canvas-guide-marker').remove();

      resetObjectBorderLine();
      updateSize();

      const zoom = canvas.getZoom();

      rulerH.resize(zoom, canvas.zoomMultiplier);
      rulerV.resize(zoom, canvas.zoomMultiplier);
      this.repositionRulers();
      this.selectedChanged({});
    },

    drawObjectsBorderLine: function (opts) {
      const selected = canvas.getSelectedElems();
      if (selected.length >= 1) {
        drawObjectsBorderLine(selected);
      }
    },

    showGuideLines: function (data) {
      drawGuideLine({
        isVerticalRuler: data.isVerticalRuler,
        guidePosition: data.guidePosition,
        isGuideLine: data.isGuideLine
      });
    },

    recalculateSelectionBox: function (opts) {
      canvas.selectorManager.releaseSelector(opts.elem);
      canvas.selectorManager.requestSelector(opts.elem).showGrips(true);
      this.mouseMove(opts);
    },

    enableRuler: function () {
      if (isRulersEnabled || INKIVE.C.IS_MOBILE) return;

      // Ignore if there are no rulers containers
      if ($('#ruler-horizontal, #ruler-vertical').length !== 2) return;

      isRulersEnabled = true;

      // Rulers
      updateFactor();
      initRulerH();
      initRulerV();
      updateSize();

      rulerH.setUnits(units);
      rulerV.setUnits(units);
    },

    disableRuler: function () {
      if (!isRulersEnabled) return;

      isRulersEnabled = false;

      rulerV.config.element.parentNode.removeChild(rulerV.config.element);
      rulerH.config.element.parentNode.removeChild(rulerH.config.element);
      $('#ruler-horizontal').hide();
      $('#ruler-vertical').hide();

      rulerV = null;
      rulerH = null;
    },

    showRulersAndGuides: function () {
      // Existing enableRuler function doesn't work as expected, so created custom show function
      showRulers();
      showGuides();
      this.repositionRulersAfterShow();

      document.querySelector('#workarea').addEventListener('scroll', (e) => {
        if (e.ctrlKey || e.metaKey) return;
        this.repositionRulersAfterShow();
      });
    },

    hideRulersAndGuides: function () {
      hideRulers();
      hideGuides();
    },

    isRulersAndGuidesShown: function () {
      return isRulersShown && isGuidesShown;
    },

    repositionRulers: function () {
      const workingArea = document.querySelector('#workarea');
      const horizontalRuler = document.querySelector('#ruler-horizontal');
      const verticalRuler = document.querySelector('#ruler-vertical');
      const horizontalRulerTickness = 22; // value in pixels.

      verticalRuler.setAttribute('style', `display: block; transform: translateX(${workingArea.scrollLeft}px)`);
      horizontalRuler.setAttribute('style', `top:0 ; left: unset; right: unset; display: block; transform: translateY(${workingArea.scrollTop + (workingArea.getBoundingClientRect().height - horizontalRulerTickness)}px)`);
    },

    repositionRulersAfterShow: function () {
      this.repositionRulers();
      moveBottomElementsOnRulerDisplay(isRulersShown);
    }
  };
};

function moveBottomElementsOnRulerDisplay (isRulersShown) {
  const horizontalScroll = document.querySelector('#ik-editor .antiscroll-scrollbar-horizontal');
  const pagesPanel = document.querySelector('#pages-panel .pages-btn-wrapper');

  pagesPanel.classList.toggle('display-ruler', isRulersShown);

  if (horizontalScroll) horizontalScroll.classList.toggle('display-ruler', isRulersShown);
}
